import { OnInit, Component, ViewChild } from '@angular/core';
import { SearchFilter, IFilterResponse } from '../../../../infrastructure/iFilter-component';
import { MatTableDataSource, MatSort } from '@angular/material';
import { SearchCompleteFilterComponent } from '../../../controls/search-complete-filter/search-complete-filter.component';
import { Router } from '@angular/router';
import { MenuService } from '../../../../services/menu.service';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { OrderBatch } from '../../../../model/logistics/order';
import { PagerControlComponent } from '../../../controls/pager/pager-control.component';
import { LogisticsService } from '../../../../services/logistics.service';
import { ConfirmDialogService } from '../../../../services/confirm-dialog.service';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-receive-order-logistics-search',
  templateUrl: './receive-order-logistics-search.component.html'
})
export class ReceiveOrderLogisticsSearchComponent implements OnInit {

  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  displayedColumns: string[] = ['name', 'star'];
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchCompleteFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor(
    private router: Router
    , private menuService: MenuService
    , private authService: AuthService
    , private logisticsService: LogisticsService
    , private confirmDialogService: ConfirmDialogService
    , private notificationToastService: NotificationToastService) {
    this.menuService.setMenuTitle('Logística', 'recepción de ordenes');
  }

  ngOnInit(): void {

  }

  receiveOrderBach(orderBatch: OrderBatch): void {
    if (orderBatch.CanEdit) {
      this.router.navigate(['receive-order-logistics-wizard', orderBatch.Id]);
    }
  }

  rollBackOrderBach(orderBatch: OrderBatch): void {
    if (!orderBatch.CanEdit) {
      this.confirmDialogService.confirm('Revertir lote'
      , 'Está seguro que desea revertir el lote?', 'Sí', 'No').subscribe(async (value) => {
        if (value) {
          try {
            this.loading = true;
            await this.logisticsService.orderBatchRollBack(orderBatch, this.authService.getSectorId());
            await this.searchFilter.search();
          } catch (err) {
            this.notificationToastService.error(JSON.stringify(err), 'Recepción de órdenes');
          } finally {
            this.loading = false;
          }
        }
      });
    }
  }

  onStartSearch(): void {
    this.loading = true;
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<OrderBatch>): void {
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
  }
}
